module.exports = __webpack_public_path__ + "static/img/coope2.a1f65fbb.png";